import { pick } from "./i18n";
import type { CatalogOutput } from "../types";

const HERO_MODES = ["packshot", "staging", "lifestyle"];

export function pickHero(outputs: CatalogOutput[], heroOutputId?: number | null): CatalogOutput | undefined {
  if (heroOutputId != null) {
    const explicit = outputs.find((output) => output.id === heroOutputId);
    if (explicit) return explicit;
  }
  for (const mode of HERO_MODES) {
    const passing = outputs.find((output) => output.mode === mode && output.qa_verdict === "pass");
    if (passing) return passing;
  }
  for (const mode of HERO_MODES) {
    const any = outputs.find((output) => output.mode === mode);
    if (any) return any;
  }
  return outputs[0];
}

export function pickGallery(outputs: CatalogOutput[], heroId: number | undefined, limit = 4): CatalogOutput[] {
  return outputs.filter((output) => output.id !== heroId).slice(0, limit);
}

const DIMENSION_LABELS: Record<"pl" | "en", Record<string, string>> = {
  pl: {
    height_cm:            "Wysokość",
    width_cm:             "Szerokość",
    depth_cm:             "Głębokość",
    seat_height_cm:       "Wysokość siedziska",
    seat_height:          "Wysokość siedziska",
    seat_h:               "Wysokość siedziska",
    seat_width_cm:        "Szerokość siedziska",
    seat_depth_cm:        "Głębokość siedziska",
    table_height_cm:      "Wysokość stolika",
    table_height:         "Wysokość stolika",
    "table height":       "Wysokość stolika",
    table_diameter_cm:    "Średnica stolika",
    table_diameter:       "Średnica stolika",
    "table diameter":     "Średnica stolika",
    armrest_height_cm:    "Wysokość podłokietnika",
    armrest_height:       "Wysokość podłokietnika",
    backrest_height_cm:   "Wysokość oparcia",
    backrest_height:      "Wysokość oparcia",
    diameter_cm:          "Średnica",
    diameter:             "Średnica",
    leg_height_cm:        "Wysokość nóg",
    leg_height:           "Wysokość nóg",
    weight_kg:            "Waga (kg)",
    max_load_kg:          "Udźwig (kg)",
    height:               "Wysokość",
    width:                "Szerokość",
    depth:                "Głębokość",
  },
  en: {
    height_cm:            "Height",
    width_cm:             "Width",
    depth_cm:             "Depth",
    seat_height_cm:       "Seat height",
    seat_height:          "Seat height",
    seat_h:               "Seat height",
    seat_width_cm:        "Seat width",
    seat_depth_cm:        "Seat depth",
    table_height_cm:      "Table height",
    table_height:         "Table height",
    "table height":       "Table height",
    table_diameter_cm:    "Table diameter",
    table_diameter:       "Table diameter",
    "table diameter":     "Table diameter",
    armrest_height_cm:    "Armrest height",
    armrest_height:       "Armrest height",
    backrest_height_cm:   "Backrest height",
    backrest_height:      "Backrest height",
    diameter_cm:          "Diameter",
    diameter:             "Diameter",
    leg_height_cm:        "Leg height",
    leg_height:           "Leg height",
    weight_kg:            "Weight (kg)",
    max_load_kg:          "Max load (kg)",
    height:               "Height",
    width:                "Width",
    depth:                "Depth",
  },
};

export function dimensionLabel(key: string): string {
  const normalized = key.toLowerCase().trim();
  const mapped = pick(DIMENSION_LABELS)[normalized];
  if (mapped) return mapped;
  return normalized.replace(/_cm$/, "").replace(/_/g, " ").replace(/\b\w/, (c) => c.toUpperCase() || c);
}
